import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { switchMap, take, map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import firebase from 'firebase/app';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    user = {
        state: null,
        profile: {
            id: '',
            photoEmailUrl: '',
            name: '',
            email: ''
        }
    };

    constructor(
        private afAuth: AngularFireAuth,
        private http: HttpClient,
        private apollo: Apollo,
        private router: Router
    ) {
    }

    load() {
        return this.afAuth.authState.pipe(take(1)).toPromise().
            then(async user => {
                if (user !== null) {
                    try {
                        this.user.profile.email = user.email;
                        this.user.profile.photoEmailUrl = user.providerData[0].photoURL;
                        const res = await this.initUser().toPromise();
                        if (res) {
                            return Promise.resolve();
                        } else {
                            this.resetUser();
                            this.afAuth.signOut();
                            return Promise.resolve();
                        }
                    } catch{
                        this.resetUser();
                        this.afAuth.signOut();
                        return Promise.resolve();
                    }
                } else {
                    return Promise.resolve();
                }
            });
    }

    initUser() {
        return this.setRoles().pipe(
            take(1),
            map((res: any) => {
                console.log(res);
                if(res.data.meSekolah) {
                    const user = res.data.meSekolah;
                    const information = {
                        id: user.id,
                        photoEmailUrl: this.user.profile.photoEmailUrl,
                        name: user.namaSekolah,
                        email: this.user.profile.email
                    };
                    this.user.profile = information;
                    this.user.state = this.afAuth.authState;

                    return true;
                } else {
                    return false;
                }
            })
        );
    }

    resetUser() {
        this.user = {
            state: null,
            profile: {
                id: '',
                photoEmailUrl: '',
                name: '',
                email: ''
            }
        };
    }

    setRoles() {
        return this.apollo.query({
            query: gql`
                query getUser{
                    meSekolah{
                        id
                        namaSekolah
                    }
                }
            `
        });
    }

    async signInWithGoogle() {
        const googleProvider = new firebase.auth.GoogleAuthProvider();
        await this.afAuth.signInWithPopup(googleProvider);
        console.log('out');
        return this.initUser().toPromise();
    }

    logout(): void {
        this.apollo.client.resetStore().then(res => {
            return this.afAuth.signOut();
        }).then(res => {
            this.resetUser();
            this.router.navigate(['/login']);
        }).catch(err => {
            this.resetUser();
            this.router.navigate(['/login']);
        });
    }
}
